import script from "./settingDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./settingDropdown.vue?vue&type=script&setup=true&lang=js"

import "./settingDropdown.vue?vue&type=style&index=0&id=abc8baba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abc8baba"]])

export default __exports__